/**
* @author XuZiYu
* @date 2019/7/9
* @time 19:39
*/
<template>
    <div class="pay-result-wrapper">
        <template v-if="$route.query.headShow === '1'">
            <ctl-header title="订单支付" :onBack="goBack"/>
        </template>
        <img class="wrapper-img" src="@/assets/public/icon_successful_payment@2x.png" alt="" v-if="flag === '1'">
        <img class="wrapper-img" src="@/assets/public/icon_failure_to_pay@2x.png" alt="" v-else>
        <p v-if="$route.query.messageTitle">{{$route.query.messageTitle}}</p>
        <p v-else>{{flag !== '1' ? '订单支付失败' : '订单支付成功'}}</p>
        <div class="btn">
            <div class="desc" v-if="flag !== '1'">
                点击“查看订单”，重新支付
            </div>
            <div class="btn-go-micro-course" @click="goMicroCourse" v-if="type === '10' && flag === '1'">
                观看课程
            </div>
            <div class="btn-go-order" @click="goOrder">
                查看订单
            </div>
            <div class="btn-go-bd" @click="goBanDou" v-if="banDouShow && appType === 1">
                斑豆中心
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant'

export default {
    name: 'vipPayResult',
    data () {
        return {
            flag: '',
            courseId: '',
            cityCode: '',
            appType: '',
            source: '',
            banDouShow: true,
            type: ''
        }
    },
    methods: {
        // 返回
        goBack () {
            if (this.$route.query.close) {
                this.$jsBridge.callBackHandler('returnLastPage')
                return
            }
            if (window.history.state && window.history.state.key) {
                this.$router.back()
            } else {
                this.$jsBridge.callBackHandler('returnLastPage')
            }
        },
        // 跳转斑豆中心
        goBanDou () {
            if (this.userInfo.userId) {
                this.$jsBridge.callBackHandler('pushBandouCenterPage')
            } else {
                this.$jsBridge.callBackHandler('loginUser')
            }
        },
        // 观看课程
        goMicroCourse () {
            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            // 获取数据
            let postData = {
                courseId: this.courseId,
                cityCode: this.cityCode
            }
            this.$api.getCourseDetail(postData).then(res => {
                Toast.clear()
                if (res.status) {
                    let courseId = this.courseId
                    let coverUrl = res.result.picture
                    let courseName = res.result.courseName
                    if (res.result.type === 1) {
                        if (this.source === 'app') {
                            this.$jsBridge.callBackHandler('returnLastPage')
                        } else {
                            this.$jsBridge.callBackHandler('pushMicroCourseVideoDetailPage', { courseId, coverUrl, courseName })
                        }
                    } else {
                        this.$router.replace({ name: 'seriesCourse', query: { id: courseId, source: this.source } })
                    }
                }
            })
        },
        goOrder () {
            if (this.appType === 100) {
                this.$router.replace(`/order?headShow=${this.$route.query.headShow}`)
                return
            }
            if (this.userInfo.userId) {
                if (this.type === '6') {
                    this.$router.replace(`/peijia/orderDetail?id=${this.$route.query.id}&headShow=${this.$route.query.headShow}`)
                    return
                }
                this.$router.replace(`/order?headShow=${this.$route.query.headShow}`)
            } else {
                this.$jsBridge.hasNativeMethod('loginUserV2')
            }
        }
    },
    mounted () {
        // 重新获取app用户数据
        let userInfo = this.$jsBridge.callBackHandler('passUserInfo')

        this.userInfo = userInfo ? JSON.parse(userInfo) : {}

        // 设置支付状态
        this.flag = String(this.$route.query.result)

        // 设置页面开通类型
        this.type = this.$route.query.type

        // 设置课程id
        this.courseId = this.$route.query.courseId

        // 设置来源
        this.source = this.$route.query.source

        // 设置城市code
        this.cityCode = this.$jsBridge.callBackHandler('passRegionCodeData') || this.$route.query.cityCode

        // 获取页面类型
        let type = this.$jsBridge.callBackHandler('getVipVideoType')

        // 设置app版本是否现实斑豆中心
        this.appType = Number(this.$jsBridge.callBackHandler('getAppType'))

        if (this.type === '6') {
            this.banDouShow = false
        }

        // 回调app开通成功
        if ((this.type === '4' || this.type === '5') && (this.flag === '1')) {
            this.$jsBridge.callBackHandler('openSuccess', { vipVideoType: type, goodsCode: this.$route.query.goodsCode, androidType: this.$route.query.isOpen ? 1 : 0 })
        }

        // 回调app开通成功
        if (this.type === '10' && this.flag === '1') {
            this.$jsBridge.callBackHandler('openMicroCourseSuccess', { vipVideoType: '10' })
        }

        if (this.$jsBridge.hasNativeMethod('pushLightingRealisticPage') && this.flag === '1' && this.$route.query.goodsCode) {
            this.$jsBridge.callBackHandler('openSuccess', { goodsCode: this.$route.query.goodsCode, androidType: this.$route.query.isOpen ? 1 : 0 })
        }
    }
}
</script>

<style scoped lang="scss">

    .pay-result-wrapper {
        text-align: center;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .wrapper-img {
            margin-top: - 50px;
            width: 93px;
        }

        p {
            margin-top: 25px;
            font-size: 18px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
        }

        .btn {
            .desc {
                margin: - 35px 0 20px;
                font-size: 14px;
                font-weight: 400;
                color: rgba(102, 102, 102, 1);
            }

            margin-top: 73px;

            .btn-go-order {
                width: 220px;
                height: 43px;
                background: rgba(83, 203, 133, 1);
                border-radius: 21.5px;
                font-size: 17px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                margin: 0 auto;
            }

            .btn-go-bd,.btn-go-micro-course {
                width: 220px;
                height: 43px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid rgba(204, 204, 204, 1);
                border-radius: 21.5px;
                font-size: 17px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                color: #333333;
                margin: 20px auto 0;
            }
            .btn-go-micro-course{
                margin: 0 0 20px 0;
            }
        }
    }
</style>
